import toType from './toType';

function validateTypeAssignment (object, scheme) {

	let isValid = true;
	Object.keys(object).forEach((key) => {

		const objectType = toType(scheme[key]);
		const schemeType = toType(object[key]);

		if (objectType !== schemeType) {

			const message = `Type change: assigment to ${key} from ${objectType} to ${schemeType}`;
			isValid = false;
			console.error(message); // eslint-disable-line no-console

		}

	});
	return isValid;

}

export default validateTypeAssignment;
